import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { Stack, Typography } from '@montugroup/design-system';
import type { ReactNode, Ref } from 'react';
import { useState } from 'react';
import submitSectionImage from '../../../assets/images/submitSectionImage.png';
import { PreOnboardingFlowContainer } from './PreOnboardingFlowContainer';
import {
  StyledSubmitSectionBackground,
  StyledSubmitSectionContainer,
  StyledSubmitSectionContentWrapper,
  StyledSubmitSectionImage,
  StyledTokenInputContainer,
} from './SubmitSectionStyles';

/** `children` replaces the onboarding flow in the card, e.g. for the expired invite page. */
export function SubmitSection({ children }: { children?: ReactNode }) {
  const [openTokenDialog, setOpenTokenDialog] = useState<boolean>(false);
  const { tokenInputRef } = usePreOnboardingContext();

  return (
    <StyledSubmitSectionBackground>
      <StyledSubmitSectionContainer>
        <StyledSubmitSectionContentWrapper>
          <Typography variant="h4" fontSize={30} fontWeight={600}>
            Alternative medication at your fingertips
          </Typography>
          <StyledTokenInputContainer ref={tokenInputRef as Ref<HTMLElement>}>
            <Stack spacing={{ xs: 8, md: 10 }}>
              {children ?? (
                <PreOnboardingFlowContainer setOpenTokenDialog={setOpenTokenDialog} openTokenDialog={openTokenDialog} />
              )}
            </Stack>
          </StyledTokenInputContainer>
        </StyledSubmitSectionContentWrapper>
        <StyledSubmitSectionImage src={submitSectionImage} alt="Hand holding a phone showing an etoken example" />
      </StyledSubmitSectionContainer>
    </StyledSubmitSectionBackground>
  );
}
